import { Paths } from "../models/constants/paths";
import { IneligibilityReasons } from "../models/constants/ineligibilityReasons";

export const getIneligibleReasonPath = (ineligibleReasons) => {
    if(ineligibleReasons.length > 1) {
        return Paths.IneligibleMultiple
    }
    switch (ineligibleReasons[0]) {
        case IneligibilityReasons.INELIGIBLE_MAKE_MODEL: 
            return Paths.IneligibleVehicleClass; 
        case IneligibilityReasons.INELIGIBLE_NO_MAKE_MATCH: 
            return Paths.IneligibleVehicleClass; 
        case IneligibilityReasons.INELIGIBLE_VEHICLE_AGE: 
            return Paths.IneligibleYear; 
        case IneligibilityReasons.INELIGIBLE_MILEAGE: 
            return Paths.IneligibleMileage; 
        case IneligibilityReasons.INELIGIBLE_LIFT_KIT_6_INCHES: 
            return Paths.IneligibleLiftkit; 
        case IneligibilityReasons.INELIGIBLE_AFTERMARKET_PERFORMANCE: 
            return Paths.IneligibleAftermarket; 
        case IneligibilityReasons.BAD_VIN_FORMAT: 
            return Paths.IneligibleVIN; 
        case IneligibilityReasons.Ineligible_VIN: 
            return Paths.IneligibleVIN; 
        case IneligibilityReasons.INCORRECT_VEHICLE_INFORMATION: 
            return Paths.IneligibleQuoteError; 
        case IneligibilityReasons.NO_ELIGIBLE_VEHICLE: 
            return Paths.InelgibleNoQualifyingInspections; 
        default: 
            return Paths.IneligibleVehicle; 
    }

}